import script from "./VPSItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VPSItem.vue?vue&type=script&setup=true&lang=js"

import "./VPSItem.vue?vue&type=style&index=0&id=77559822&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77559822"]])

export default __exports__